<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'manage-image'"
    @hidden="$emit('onCloseModal')"
    @show="fetchImageData"
  >
    <b-form @submit.prevent="onSubmitModal">
      <div class="row mb-1">
        <div class="col-12 p-0">
          <div class="information-header">
            {{ isEdit ? 'Edit Image' : 'Add Image' }}
          </div>
        </div>
      </div>
      <div class="modal-wrp mx-3">
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Image Type'"
              label-class="font-medium-5"
            >
              <b-form-radio-group
                v-model="formData.imageType"
                :options="imageTypeOptions"
                class="custom-radio-group"
                :class="{ bypass: isEdit }"
                :disabled="isEdit"
                @change="onChangeImgType"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Name'"
              label-for="name"
              label-class="font-medium-5 required"
            >
              <b-form-input
                id="name"
                v-model="formData.name"
                :placeholder="'ระบุ'"
                required
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Description (Th)'"
              label-for="desc"
              label-class="font-medium-5"
            >
              <b-form-textarea
                id="desc"
                v-model="formData.descTh"
                :placeholder="'ระบุ'"
                no-resize
                rows="3"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Description (En)'"
              label-for="descEn"
              label-class="font-medium-5"
            >
              <b-form-textarea
                id="descEn"
                v-model="formData.descEn"
                :placeholder="'ระบุ'"
                no-resize
                rows="3"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Key'"
              label-for="key"
              label-class="font-medium-5 required"
            >
              <b-form-input
                id="key"
                v-model="formData.key"
                :placeholder="'ระบุ'"
                required
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <b-form-group
              :label="'Remark'"
              label-for="remark"
              label-class="font-medium-5"
            >
              <b-form-input
                id="remark"
                v-model="formData.remark"
                :placeholder="'ระบุ'"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <label class="font-medium-5">Image</label>
            <image-uploader
              v-if="formData.imageType == 1"
              :image-url="
                formData.imageList.length > 0
                  ? formData.imageList[0].image_url
                  : null
              "
              @onUpload="onUploadImage"
              @onDelete="onDeleteImage"
            />

            <image-multiple-upload
              v-else
              :image-data-list="formData.imageList"
              @onUpload="onUploadImageMultiple"
              @onDelete="onDeleteImageMultiple"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="modal-btn-wrp mt-2 mb-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button
                class="ml-1"
                type="submit"
              />
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </base-modal>
</template>

<script>
import ImageMultipleUpload from './ImageMultipleUpload.vue'
import useManageImageListModal from '../../hooks/useManageImageListModal'

export default {
  components: { ImageMultipleUpload },
  props: {
    imageObj: { type: Object, default: {} },
    isEdit: { type: Boolean, default: false },
  },
  setup(props) {
    const {
      formData,
      imageTypeOptions,
      fetchImageData,
      onUploadImage,
      onDeleteImage,
      onUploadImageMultiple,
      onDeleteImageMultiple,
      onSubmitModal,
      onChangeImgType,
    } = useManageImageListModal(props)

    return {
      formData,
      imageTypeOptions,
      fetchImageData,
      onUploadImage,
      onDeleteImage,
      onUploadImageMultiple,
      onDeleteImageMultiple,
      onSubmitModal,
      onChangeImgType,
    }
  },
}
</script>
